import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {Group} from '../../../graphql/groups.datatypes';

interface GroupData {
    group: Group
}

export const gqlGroup = `
    id
    tour_resource_id
    hotel_resource_id
    name
    start_date
    start_date_additional
    end_date
    end_date_additional
    max_additional_nights
    disabled
    locked

    bookings {
        id

        roomParties {
            id
            disabled
            start_date
            end_date

            hotel {
              id
              internal_name
            }

            roomResource {
                id
                resource {
                    id
                    guest_capacity
                }
            }

            members {
                id
                primary_occupant

                groupMember {
                    id
                    first_name
                    last_name
                }
            }
        }
    }
`;

export const GET_GROUP_QUERY = gql`
    query getGroupMerge($id: Int!){
        group(id: $id){
          ${gqlGroup}
        }
    }
`;

export const getGroup = (groupId: number | null) => {
    const id = groupId ? groupId : -1;
    return useQuery<GroupData>(
        GET_GROUP_QUERY,
        {
            variables: {id},
        }
    );
};

export default getGroup;
